import React from 'react';
import { Link } from 'react-router-dom';

const legalLinks = [
  {
    name: "Mentions légales",
    path: "/mentions-legales"
  },
  {
    name: "Termes et conditions",
    path: "/termes-et-conditions"
  },
  {
    name: "Politique de confidentialité",
    path: "/confidentialite"
  }
];

const LegalLinks = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Informations légales</h3>
      <ul className="space-y-2">
        {legalLinks.map((link) => (
          <li key={link.path}>
            <Link
              to={link.path}
              className="text-gray-600 hover:text-orcsys-500 transition-colors"
            >
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LegalLinks; 